import { useSubscriptionsLoader } from "shared/hooks/SubscriptionsLoader";
import { getFormattedNumber } from "shared/utility/NumberUtility";

export default function ManageTokenGridBanner() {
  // We will not load subscriptions if already loaded. That's why, forceLoad option is false.
  const [currentSubscription] = useSubscriptionsLoader(false);

  const dailyLimit = currentSubscription
    ? currentSubscription.numberOfAllowedActions
    : 0;
  const dailyConsumed = currentSubscription
    ? currentSubscription.consumptionSummary
      ? currentSubscription.consumptionSummary.consumedActions
      : 0
    : 0;

  const TransactionInformation = () => {
    const InformationColumn = ({
      title,
      value,
      rightAlign,
      className,
    }: {
      title: string;
      value: string;
      rightAlign?: boolean;
      className?: string;
    }) => {
      return (
        <div
          className={`inline-block ${rightAlign ? "text-right" : "text-left"} ${
            className ?? ""
          }`}
        >
          <div className="text-promGray2">{title}</div>
          <div className="text-4xl font-semibold">{value}</div>
        </div>
      );
    };

    return (
      <div>
        <InformationColumn
          title={"Transactions last 24hrs"}
          value={getFormattedNumber(dailyConsumed)}
          rightAlign
          className="mr-10"
        />
        <InformationColumn title={""} value={"/"} className="mr-10" />
        <InformationColumn
          title={"Daily limit"}
          value={getFormattedNumber(dailyLimit)}
        />
      </div>
    );
  };

  return (
    <div className="py-5 px-10 rounded bg-white shadow-custom">
      <div className="flex">
        <div className="w-1/2">
          <div className="font-bold mb-2 text-2xl">Personal Access Tokens</div>
          <span>
            Tokens, paired with a unique access key, are used to access the
            timePhasing API. Each token tracks its own usage metrics, so you can
            see how many transactions it completes. Tokens can also be given
            expiration dates for better security.
          </span>
        </div>
        <div className="w-1/2 flex items-center justify-end">
          <TransactionInformation />
        </div>
      </div>
    </div>
  );
}
